import { withTranslation } from "next-i18next";
import { useState, useEffect, useRef } from "react";
import { getUserListSuggestedProducts } from "@utils/call-api/userlists-call";
import Slider from "@components/core/Slider";

import SuggestedProductCard from "./SuggestedProductCard";

function UserListSuggestedProducts({ userListUuid, fetchUserList, t }) {
  const [suggestedProducts, setSuggestedProducts] = useState([]);

  const sliderRef = useRef(null);

  function setSliderRef(ref) {
    sliderRef.current = ref;
  }

  function onProductAddedToUserList(productAddedId) {
    fetchUserList();

    setSuggestedProducts(suggestedProducts.filter((product) => product.id !== productAddedId));
  }

  const cards = () => {
    return suggestedProducts.map((product) => (
      <SuggestedProductCard
        key={product.id}
        userListUuid={userListUuid}
        product={product}
        onProductAddedToUserList={onProductAddedToUserList}
      />
    ));
  };

  useEffect(() => {
    async function fetchSuggestedProducts() {
      const res = await getUserListSuggestedProducts(userListUuid);
      setSuggestedProducts(res);
    }

    if (userListUuid) fetchSuggestedProducts();
  }, [userListUuid]);

  if (!suggestedProducts.length) return null;

  return (
    <div className="w-100 bg-white py-5 mt-5 mb-6">
      <div className="pb-4 mb-2 d-flex flex-column align-items-center">
        <h5 className="text-center mb-0">{t("catalog:userlist.wishlist.title")}</h5>
        <p className="mb-0 text-gray">{t("catalog:userlist.wishlist.subtitle")}</p>
      </div>

      <div className="d-flex justify-content-center w-100">
        <div className="userlist-suggested-products-container">
          {!!suggestedProducts.length && (
            <Slider
              name="userlist-suggested-products"
              setSliderRef={setSliderRef}
              cards={cards()}
              productSliderRef={sliderRef}
              gapSize={16}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default withTranslation("catalog")(UserListSuggestedProducts);
